import * as React from 'react';
import styles from './ConfirmationStep.module.scss';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import { plural } from 'utils/format';
import { ReactComponent as CheckIcon } from './assets/ic-check-circle.svg';
import { ReactComponent as MailIcon } from './assets/ic-mail-outline.svg';
import BiggestUserInspection from '../../../../components/BiggestUserInspection';
import { remotePaths } from 'router/routes';

export default function ConfirmationStep({
  dueDay = 30,
  taxAuthority,
  children,
  className,
  withoutMessage,
  message,
  showBiggest,
}) {
  return (
    <div className={className}>
      <div className={styles.content}>
        <div className={styles.header}>
          <CheckIcon />
          Готово
        </div>
        {renderTaxAuthority(taxAuthority, showBiggest)}
        {!withoutMessage && (
          <p>
            Обработка обращений проводится в течение {dueDay}{' '}
            {plural(dueDay, 'дня', 'дней', 'дней')} с даты регистрации обращения.
          </p>
        )}
        <div>{children}</div>
        <div className={styles.help}>{message}</div>
      </div>
      <div>
        <div className={cn(['steps_button', styles.button])}>
          <a className="button button__medium button__white" href={remotePaths.situations}>
            Выйти
          </a>
          <a
            className={`button button__medium button__blue justify-content-center ${styles.mailButton}`}
            href={remotePaths.messages}
          >
            <MailIcon />
            Сообщения
          </a>
        </div>
      </div>
    </div>
  );
}

function renderTaxAuthority(taxAuthority, showBiggest) {
  if (!taxAuthority) {
    return;
  }
  let result;
  if (typeof taxAuthority === 'string' || React.isValidElement(taxAuthority)) {
    result = taxAuthority;
  } else {
    const { name, code } = taxAuthority;
    result = [code, name].filter((v) => v).join(' — ');
  }
  return (
    <p>
      Ваше заявление будет направлено в налоговый орган{' '}
      {showBiggest ? (
        <b>
          <BiggestUserInspection withoutField>{result}</BiggestUserInspection>
        </b>
      ) : (
        <b>{result}</b>
      )}
    </p>
  );
}

ConfirmationStep.defaultProps = {
  message:
    'Ответ будет направлен в Личный кабинет. Отслеживать статус обработки можно в разделе «Сообщения»',
};

ConfirmationStep.propTypes = {
  cardId: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  dueDay: PropTypes.number,
  message: PropTypes.any,
  taxAuthority: PropTypes.object,
  withoutMessage: PropTypes.bool,
  showBiggest: PropTypes.bool,
};
